import { Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UntypedFormBuilder} from '@angular/forms';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UserService} from '../../services/user/user.service';
import {ShipmentAuditTrailService} from '../../services/shipment-audit-trail/shipment-audit-trail.service';
import {Location} from '@angular/common';
import {ColDef, ColGroupDef, GridApi, GridOptions} from 'ag-grid-community';
import AppConstants from 'src/app/shared/common-components/AppConstants';
import moment from 'moment';

@Component({
    selector: 'app-shipment-audit-trail',
    templateUrl: './shipment-audit-trail.component.html',
    styleUrls: ['./shipment-audit-trail.component.css'],
    standalone: false
})
export class ShipmentAuditTrailComponent implements OnInit {

    auditTrailLogList: any = [];
    routeParamShipmentId: number;
    routeParamDRNNumber: any;
    currentUser: any;
    isSysAdmin = false;

    audits: any = null;
    private tmssloader;


    // Pagination
    // Pagination Variables
    itemsPerPage = 10;
    totalItems = 0;
    currentPage = 1;
    pageReset = false;
    previousPage = 0;
    auditTrailLogListSliced: any = null;
    pageMap: Map<number, any> = new Map<number, any>();
    showingStart: number;
    showingEnd: number;
    bookShipmentId: number;

    shipmentAuditTrailGridOption: GridOptions = this.initializeGridOptions();
    gridApi: GridApi;
    columnDefs: ColDef[];

    constructor(private fb: UntypedFormBuilder,
        private alertService: AlertService,
        private loader: LoadingService,
        private route: ActivatedRoute,
        private shipmentAuditTrailService: ShipmentAuditTrailService,
        private location: Location
    ) {
        this.tmssloader = this.loader;
    }

    ngOnInit() {
        this.tmssloader.show();
        console.log('In ngOnInit().. ');
        this.routeParamShipmentId = this.route.snapshot.queryParams['shipmentId'];
        this.bookShipmentId = this.route.snapshot.queryParams['bookshipmentid'];
        console.log('this.routeParamShipmentId ' + this.routeParamShipmentId);
        this.getAuditTrailList(this.routeParamShipmentId);
        // window.scrollTo(0, 0);
        this.columnDefs = this.getShipmentAuditTrailColumnDefs();
    }

    private initializeGridOptions() {
        return <GridOptions>{
          rowSelection: 'multiple',
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agTextColumnFilter',
            filterParams: {
              suppressAndOrCondition: true
            }
          },
          headerHeight: 50,
          pagination: true,
          paginationPageSize: 25,
          cacheBlockSize: 25,
          domLayout: 'autoHeight',
          onGridReady: params => {
            this.gridApi = params.api;
            params.api.sizeColumnsToFit();
          },
          overlayLoadingTemplate:
            '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
        };
      }

    getShipmentAuditTrailColumnDefs(): (ColDef | ColGroupDef)[] {
        return [
            <ColDef>
            {
                headerName: 'Date',
                cellRenderer: (params: any) => {
                    const dataTime = params.data.updateDate;
                    return (AppConstants.isNotNullCondition(dataTime)) ? this.getShortDate(dataTime) : '';
                },
                filter: 'agTextColumnFilter'
            },
            {
                headerName: 'Time',
                cellRenderer: (params: any) => {
                    const dataTime = new Date(params.data.updateDate);
                    return (AppConstants.isNotNullCondition(dataTime)) ? this.getTime(dataTime) : '';
                },
                filter: 'agTextColumnFilter'
            },
            {
                headerName: 'Field Name',
                field: 'fieldName',
                filter: 'agTextColumnFilter'
            },
            {
                headerName: 'From',
                field: 'oldValue',
                filter: 'agTextColumnFilter'
            },
            {
                headerName: 'To',
                field: 'newValue',
                filter: 'agTextColumnFilter',
            },
            {
                headerName: 'User Email Address',
                field: 'updateEmailAddress',
                filter: 'agTextColumnFilter'
            }
        ];
    }

    getShortDate(param: any){
        return moment(param).format("DD-MM-YYYY HH:mm:ss");                                                                                  
    }

    getTime(param: any){
        return moment(param).format('h:mm:ss A');
    }
    
    // Get the Audit Trail records for a provided shipmentsId
    getAuditTrailList(shipmentId: number) {
        this.auditTrailLogList = [];
        this.tmssloader.show();
        this.shipmentAuditTrailService.getAuditTrailListByShipmentId(shipmentId)
            .subscribe(data => {
                if (data) {
                    this.auditTrailLogList = data.sort((objA: any, objB: any) =>{
                        return Number(new Date(objB.updateDate)) - Number(new Date(objA.updateDate));
                    } );
                    this.columnDefs = this.getShipmentAuditTrailColumnDefs();
                    console.log('Successfully retrieved audit records And auditTrailLogList length: ' + this.auditTrailLogList.length);
                    // this.setupPagination();
                    this.tmssloader.hide();
                }
            }, (error) => {
                console.log('There was an error retrieving auditTrailLog records');
                this.tmssloader.hide();
                this.alertService.error('There was an error retrieving auditTrailLog records');
            });
    }

    // Set Up Pagination Map. Create a Map with key representing page number and value as a list of object.
    // setupPagination() {
    //     this.pageMap = new Map<number, any>();
    //     this.totalItems = this.auditTrailLogList.length;
    //     let pageCount = 1;
    //     for (let i = 0; i < this.totalItems; i = i + this.itemsPerPage) {
    //         const pageOfCustomers = this.auditTrailLogList.slice(i, i + this.itemsPerPage);
    //         this.pageMap.set(pageCount, pageOfCustomers);
    //         pageCount++;
    //     }
    //     // Reset the current page to the first page
    //     this.currentPage = 1;
    //     this.auditTrailLogListSliced = this.pageMap.get(this.currentPage);
    //     this.showingStart = 1;
    //     //      this.showingEnd = this.currentPage * this.itemsPerPage;      
    //     const end = this.currentPage * this.itemsPerPage;
    //     if (end > this.totalItems) {
    //         this.showingEnd = this.totalItems;
    //     } else {
    //         this.showingEnd = end;
    //     }

    // }

    // page event emitted from pagination component. Set the Current page as long as there is data to be displayed
    // page(currentPage) {
    //     this.currentPage = currentPage;
    //     if (this.auditTrailLogListSliced != null && this.auditTrailLogListSliced != []) {
    //         this.auditTrailLogListSliced = this.pageMap.get(currentPage);
    //     }

    //     const end = this.currentPage * this.itemsPerPage;
    //     if (end > this.totalItems) {
    //         this.showingEnd = this.totalItems;
    //     } else {
    //         this.showingEnd = end;
    //     }

    //     //     this.showingEnd = this.currentPage * this.itemsPerPage;
    //     this.showingStart = (this.currentPage * this.itemsPerPage) - this.itemsPerPage + 1;
    // }

    // // set the value of items per page when change from pagination component
    // // this value is used for mapping in setupPagination() function
    // itemsPerPageChanged(itemsPerPage) {
    //     console.log('Resetting Up Pagination!' + itemsPerPage);
    //     this.itemsPerPage = itemsPerPage;
    //     if (this.auditTrailLogListSliced != null && this.auditTrailLogListSliced !== []) {
    //         this.setupPagination();
    //         this.pageReset = true;
    //     }
    // }

    goBack() {
        this.location.back();
    }
}
